import React from 'react';
import { Paper, Typography, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const KpiCard = ({ title, goal = 0, progress = 0 }) => {
  const theme = useTheme();
  const pct = goal ? (progress / goal) * 100 : 0;

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        m: 2,
        width: { xs: '100%', sm: '48%', md: '30%' },
        bgcolor: theme.palette.background.paper,   // guarantees readable surface
        color: theme.palette.text.primary,         // guarantees readable text
      }}
    >
      <Typography variant="h6" gutterBottom fontWeight={600}>
        {title}
      </Typography>

      <Typography variant="body2">Goal: {goal}</Typography>
      <Typography variant="body2" mb={1}>
        Progress: {progress}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={pct}
        sx={{
          height: 8,
          borderRadius: 5,
          '& .MuiLinearProgress-bar': {
            borderRadius: 5,
            backgroundColor:
              pct >= 100 ? theme.palette.success.main : theme.palette.primary.main,
          },
        }}
      />
    </Paper>
  );
};

export default KpiCard;
